import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconEmail = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z" />
  </SvgIcon>
);

export default IconEmail;



// WEBPACK FOOTER //
// ./src/components/icons/IconEmail.js